import { Box, Typography } from "@mui/material";
import DriverRequestsTable from "Components/DriversRequests/DriversRequestsTable";
import { useRTL } from "hooks/isRTL";

const DriversRequests = () => {
  const { t } = useRTL();
  return (
    <Box
      sx={{
        padding: "3.2rem 4.5rem",
        // backgroundColor: "#ecf0f1", back hrtr
        height: "100%",
        overflowY: "auto",
      }}
    >
      <Typography variant="h1">{t("driversRequests")}</Typography>

      <DriverRequestsTable />
    </Box>
  );
};

export default DriversRequests;
